import React from 'react';

interface ArticleEmptyBlockProps {
	height: any;
}

const ArticleEmptyBlockComponent = (props: ArticleEmptyBlockProps) => {
	return (
		<div
			className="articleEmptyBlockComponent"
			style={{
				height: props.height
			}}
		></div>
	);
};

export default ArticleEmptyBlockComponent;